"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeeByTx = exports.getFeesByWavesMoney = void 0;
const cross_fetch_1 = require("cross-fetch");
const utils_1 = require("./utils");
const DEFAULT_FEE = 100000;
const getFeesByWavesMoney = (fees, wavesMoney) => {
    const count = wavesMoney.getCoins()
        .div(DEFAULT_FEE)
        .roundTo(0, 0 /* ROUND_UP */);
    return fees.reduce((acc, money) => {
        if (money.asset.id === 'WAVES') {
            acc.push(wavesMoney);
        }
        else {
            const feeInMoney = money.cloneWithTokens(money.getTokens().mul(count));
            if (feeInMoney.lte(money)) {
                acc.push(feeInMoney);
            }
        }
        return acc;
    }, []);
};
exports.getFeesByWavesMoney = getFeesByWavesMoney;
const getFeeByTx = (wavesAsset, fees, tx, nodeUrl = 'https://nodes.waves.exchange') => __awaiter(void 0, void 0, void 0, function* () {
    const { feeAmount } = yield cross_fetch_1.default(`${nodeUrl}/transactions/calculateFee`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign(Object.assign({}, tx), { feeAssetId: null }))
    }).then(res => {
        if (res.status >= 400) {
            throw new Error("Bad response from server");
        }
        return res.text();
    }).then(utils_1.parseJSON);
    const txFee = new utils_1.MyMoney(feeAmount, wavesAsset);
    return exports.getFeesByWavesMoney(fees, txFee);
});
exports.getFeeByTx = getFeeByTx;
